import type { IValidatedResponse } from '../../httpClient';
import { postRequest } from '../../httpClient';
import type { IVerifyReceiptRequest } from './verify-receipt-request';
import type { IVerifyReceiptResponse } from './verify-receipt-response';
import { verifyReceiptResponseSchema } from './verify-receipt-response';

export async function verifyReceiptApi(
  body: IVerifyReceiptRequest,
): Promise<IValidatedResponse<IVerifyReceiptResponse>> {
  return postRequest<IVerifyReceiptResponse>({
    path: '/billing/verify-receipt',
    body,
    schema: verifyReceiptResponseSchema,
  });
}
